<template>
  <div>
    <el-dialog
      :title = "editType == 'edit' ? '编辑' : '修改' "
      :visible.sync = "visible"
      :close-on-click-model="false"
      @close="projectDailogClose"
      append-to-body
      :width="`${900}px`"
    >
      <el-form ref="form" label-position="right" :model="formChild" label-width="120px">
        <el-form-item label="项目名称">
          <el-input style="width: 520px" readonly v-model="formChild.name" type="textarea" ></el-input>
        </el-form-item>
        <el-form-item label="结算类型" >
          <template v-if="showSettleType">
            <el-radio-group v-model="formChild.settleType">
              <el-radio :label="1">月度暂结</el-radio>
              <el-radio :label="2">整单暂结</el-radio>
              <el-radio :label="0">整单结算</el-radio>
            </el-radio-group>
            <el-button @click="refreshSettleType" style="color: green;margin-left: 20px;" icon="el-icon-refresh" size="mini" type="text">不变</el-button>
          </template>
          <template v-else>
            保持不变  <el-button @click="showSettleType = true" style="color: red" icon="el-icon-edit" size="mini" type="text">修改</el-button>
          </template>
        </el-form-item>
        <el-form-item label="结算数据源" >
          <template v-if="showDataType">
            <el-select  v-model="formChild.dataType" size="small" clearable placeholder="请选择结算数据源">
              <el-option label="秒针IES" :value="1"></el-option>
              <el-option label="乐播云" :value="2"></el-option>
              <el-option label="客户数据-实结" :value="3"></el-option>
              <el-option label="客户数据-全结" :value="4"></el-option>
              <el-option label="历史结算导入" :value="5"></el-option>
            </el-select>
            <el-button @click="refreshDataType" style="color: green;margin-left: 20px;" icon="el-icon-refresh" size="mini" type="text">不变</el-button>
          </template>
          <template v-else>
            保持不变  <el-button @click="showDataType = true" style="color: red" icon="el-icon-edit" size="mini" type="text">修改</el-button>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" icon="el-icon-circle-check" @click="updateDtOrSt">提交</el-button>
        <el-button @click="projectDailogClose" size="small" type="info" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateDtOrSt } from '@/api/projectSettlement/procedure'
export default {
  props: {
    projectDialogFlag: {
      type: Boolean,
      default: false
    },
    projectInfo: {
      type: Object,
      default: () => {}
    },
    changeProject: {
      type: Object,
      default: () => []
    },
    orderIds: {
      type: String,
      default: ''
    },
    editType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      visible: false,
      formChild: {
        orderIds: '',
        name: '',
        settleType: 0,
        dataType: 1
      },
      showSettleType: false,
      showDataType: false,
      formRules: {
        settleType: [{
          required: true, message: '请选择结算类型', trigger: 'change'
        }],
        dataType: [{
          required: true, message: '请选择结算数据源', trigger: 'blur'
        }]
      },
    }
  },
  mounted() {

  },
  methods: {
    projectDailogClose() {
      this.$refs.form.clearValidate()
      this.$emit('update:projectDialogFlag', false)
    },
    updateDtOrSt() {
      this.$refs.form.validate( valid => {
        if (valid) {
          updateDtOrSt({
            settleId: this.projectInfo.id,
            orderIds: this.formChild.orderIds,
            settleType: this.formChild.settleType,
            dataType: this.formChild.dataType
          }).then(res => {
            if(res.data.code === 200) {
              this.projectDailogClose()
            }
          }).catch(err => {
            this.projectDailogClose()
            console.log(err)
          })
        }
      })
    },
    refreshSettleType() {
      this.showSettleType = false
      if(this.changeProject.length === 1) {
        this.formChild.settleType = this.changeProject[0].settleType
      } else {
        this.formChild.settleType = ''
      }
    },
    refreshDataType() {
      this.showDataType = false
      if(this.changeProject.length === 1) {
        this.formChild.dataType = this.changeProject[0].dataType
      } else {
        this.formChild.dataType = ''
      }
    }
  },
  watch: {
    projectDialogFlag() {
      this.visible = this.projectDialogFlag
    },
    changeProject() {
      this.formChild.orderIds = this.changeProject.map(item => item.orderId).join(',')
      this.formChild.name = this.changeProject.map(item => item.orderName).join(',')
      this.showDataType = false
      this.showSettleType = false
      if(this.changeProject.length === 1) {
        this.formChild.settleType = this.changeProject[0].settleType
        this.formChild.dataType = this.changeProject[0].dataType
      } else {
        this.formChild.settleType = ''
        this.formChild.dataType = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>